export const INVOICE_PAID_STATUS = 'INVOICE_PAID_STATUS';
export const INVOICE_UNKNOWN_STATUS = 'INVOICE_UNKNOWN_STATUS';

export const extraColumns = [
    {
        key: 'debt',
        name: 'plans.debt.totalOutstanding',
    },
    {
        key: 'overdue',
        name: 'plans.debt.overdue',
        isNegative: true,
        isInverted: true,
    },
    {
        key: 'overdue30d',
        name: 'plans.debt.overdue30d',
        isBold: true,
        isNegative: true,
        isInverted: true,
    },
];

export const DebtFilterFormName = 'DEBT_DETAIL_FILTERS';

export enum DebtTypeFilter {
    ALL = 'SHOW_ALL',
    OVERDUE = 'OVERDUE',
    THIRTY_DAY_OVERDUE = '30D_OVERDUE',
    OUTSTANDING = 'OUTSTANDING',
}

export const PaymentSourceNotSet = 'NOT_SET_UP';

export const Limit = 50;
